import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

export default function ProductDetails(props) {
    return (
        <Row id={`product-detail-row-${props.id}`} name="product-detail-row">
            <Col sm="6" className="mt-2" id={`product-detail-col-${props.id}`} name="product-detail-col">
                <span id={`product-description-${props.id}`} name="product-description" dangerouslySetInnerHTML={{ __html: props.productDescription }} />
            </Col>

            <Col sm="6" className="mt-2" id={`product-information-${props.id}`} name="product-information">
                <p id={`product-info-label`} name={`product-info-label`}>
                    <strong>Product Information</strong>
                </p>
                <ul id={`product-info-${props.id}`} name="product-info" dangerouslySetInnerHTML={{ __html: props.productInformation }} />
            </Col>
        </Row>
    );
}

ProductDetails.propTypes = {
    productDescription: PropTypes.string.isRequired,
    hasPermConversion: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/SubComponent/ProductDetails.js